import { useCallback } from 'react'
import ButtonModalSortList, { ItemSortFunction } from '../../../../../../../../../baseComponents/Sorts/ButtonModalSortList'
import { BaseButtonModalSortListProps } from '../../../../../../../../../baseComponents/Sorts/ButtonModalSortList/types'
import { twinFetchPostText } from '../../../../../../../../../utils/globals/data'
import { useParams } from 'react-router-dom'

interface WorkSheetProductStatusSortButtonProps extends BaseButtonModalSortListProps {
}

const WorkSheetProductStatusSortButton: React.FC<WorkSheetProductStatusSortButtonProps> = ({ ...rest }) => {
    const { updateWorkSheetProduct } = useWorkSheetProductStatusSortButtonLogic()
    const { WorkSheetGroupStatusId } = useParams()
    return (
        <ButtonModalSortList updateData={updateWorkSheetProduct} getDataFrom='/api/app/order/sell/workSheet/workSheetProductStatus/getAllWorkSheetProductStatuses' extraWhereParams={{ WorkSheetGroupStatusId }} {...rest} />
    )
}

const useWorkSheetProductStatusSortButtonLogic = () => {
    const updateWorkSheetProduct: ItemSortFunction = useCallback(async (data) => {
        const resp = await twinFetchPostText('/api/app/order/sell/workSheet/workSheetProductStatus/updateWorkSheetProductStatusOrder', { productStatus: data })
        if (resp) {
            return true
        }
        return false
    }, [])

    return { updateWorkSheetProduct }
}

export default WorkSheetProductStatusSortButton